import { render } from "./chessGame.vue?vue&type=template&id=1bc2c143&scoped=true"
import script from "./chessGame.vue?vue&type=script&lang=js"
export * from "./chessGame.vue?vue&type=script&lang=js"

import "./chessGame.vue?vue&type=style&index=0&id=1bc2c143&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc2c143"]])

export default __exports__